import { Ng2StateDeclaration } from '@uirouter/angular';
import { FiAuthenticateAgreementComponent } from '@fi-app/authenticate/agreement/agreement.component';
import { PageTitleService } from '@fi-app/utilities/fi-services/page-title.service';
import { AgreementService } from '@fi-app/agreement/agreement.service';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';

export const FiAuthStatesLoginLicenceAgreementState: Ng2StateDeclaration = {
    name: FiStateNames.Login.LicenceAgreement,
    url: '/LicenceAgreement/:UserPreferredContentLanguageId/:DefaultContentLanguageId',
    component: FiAuthenticateAgreementComponent,
    params: {
        adCredentials: null,
        loginData: null,
        agreementNotAcceptedResponse: null,
    },
    resolve: {
        agreement: [AgreementService, FiAuthStatesLoginLicenceAgreementResolve_agreement_resolveFunc],
        pageTitle: [PageTitleService, 'agreement', FiAuthStatesLoginLicenceAgreementResolve_pageTitle_resolveFunc],
    },
};

export function FiAuthStatesLoginLicenceAgreementResolve_agreement_resolveFunc(agreementService: AgreementService) {
    return agreementService.GetLicenseAgreement();
}

export function FiAuthStatesLoginLicenceAgreementResolve_pageTitle_resolveFunc(
    pageTitleService: PageTitleService,
    agreement,
) {
    return pageTitleService.setTitle('Login Licence Agreement View - ' + agreement.Name);
}
